//// filepath: /d:/workspace/1/branchs/noiz-frontend/src/components/quest/TwitchAuthModal.js
import React from 'react';
import './TwitchAuthModal.scss';

const toConnectAccounts = () => window.location.assign('/connect-accounts');

const TwitchAuthModal = ({ onClose }) => {
  return (
    <div className="twitch-auth-modal-overlay">
      <div className="twitch-auth-modal">
        <div className="modal-close" onClick={onClose}>
          <svg viewBox="0 0 24 24">
            <path d="M18 6L6 18M6 6l12 12" stroke="#99969C" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>
        <div className="modal-header">
          <div className="red-circle">
            <svg viewBox="0 0 24 24" width="48" height="48" fill="none">
              <path d="M12 9v4m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
                    stroke="white" 
                    strokeWidth="2.5" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="auth-title">Authorize Again</div>
        </div>
        <div className="modal-body">
          You need to authorize twitch again
        </div>
        <div className="modal-footer">
          <button className="retry-button" onClick={toConnectAccounts}>Retry</button>
        </div>
      </div>
    </div>
  );
};

export default TwitchAuthModal;